import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from 'src/core/services/alert.service';
import { BatchService } from 'src/core/services/batch.service';
import { RawOrderItem } from 'src/interfaces/order';
import {
  FulfilmentItem,
  FocusedInput,
  OrderItem,
} from 'src/interfaces/order-item';

@Component({
  selector: 'core-order-item-fulfilment-list',
  templateUrl: './order-item-fulfilment-list.component.html',
  styleUrls: ['./order-item-fulfilment-list.component.scss'],
})
export class OrderItemFulfilmentListComponent implements OnInit {
  @Input() displayedColumns: string[] = [];

  @Input() items: FulfilmentItem[] = [];

  startIndex: number = 0;
  activeItem: FulfilmentItem | null = null;
  FocusedInput = FocusedInput;

  constructor(
    private _batchService: BatchService,
    private _alertService: AlertService
  ) {}

  ngOnInit(): void {}

  scanned(item: FulfilmentItem): boolean {
    return item.scanned === item.orderItem.quantity;
  }
  async onBarcodeBlur(item: FulfilmentItem) {
    const barcodeInput = item.barcodeInput.value;
    if (!barcodeInput) return;
    const batchNumber = barcodeInput.split('-')[0];
    const data =
      (await this._batchService.getBatchByBatchNumber(batchNumber)) || null;
    if (!data) return;
    console.log(data.expiry_date);
    if (data.expiry_date) {
      const expiry_date = data.expiry_date;
      const expiryDate = new Date(expiry_date);
      const now = new Date();
      if (expiryDate < now) {
        console.log('Expired');
        this._alertService.warningAlert(
          `This medicine has passed the expiry date of ${
            expiryDate.toISOString().split('T')[0]
          }`
        );
        // Clear the FormControl's value
        item.barcodeInput.setValue('');
        // Optionally, refocus the input field
        this.focusBarcode(item);
      } else {
        // Warn if less than two months (approx. 60 days) remain before expiry
        const msUntilExpiry = expiryDate.getTime() - now.getTime();
        const sixtyDaysMs = 1000 * 60 * 60 * 24 * 60;
        if (msUntilExpiry <= sixtyDaysMs) {
          this._alertService.warningAlert(
            `This medicine will expire on ${
              expiryDate.toISOString().split('T')[0]
            }. Less than two months remaining.`
          );
        }
      }
    }
  }
  activateItem(item: FulfilmentItem) {
    // check if there was an active item
    if (item.activated) return;

    const previvousActiveItem: FulfilmentItem | undefined = this.items.find(
      (item) => {
        if (!this.activeItem) return false;
        return item.orderItem.id == this.activeItem.orderItem.id;
      }
    );

    if (previvousActiveItem) {
      previvousActiveItem.activated = false;
      previvousActiveItem.focusedInput = FocusedInput.None;
      previvousActiveItem.barcodeInput.reset();
      previvousActiveItem.medicineNumberInput.reset();
    }

    this.activeItem = item;

    item.activated = true;
    // Only execute this if item was not activated by
    // focusing an input
    this.focusBarcode(item);
  }

  percentage(item: FulfilmentItem): number {
    return (item.scanned / item.orderItem.quantity) * 100;
  }

  focusBarcode(item: FulfilmentItem) {
    const input: HTMLInputElement = <HTMLInputElement>(
      document.querySelector(`#${item.barcodeInputId}`)
    );
    input.focus();
    this.activateItem(item);
    item.focusedInput = FocusedInput.Barcode;
  }

  focusMedicineNumber(item: FulfilmentItem) {
    const input: HTMLInputElement = <HTMLInputElement>(
      document.querySelector(`#${item.medicineNumberInputId}`)
    );
    input.focus();
    this.activateItem(item);
    item.focusedInput = FocusedInput.MedicineNumber;
  }

  async openDetails(item: OrderItem) {
    await this._batchService.openOrderItemDetailsDialog(item, null);
  }
}
